import React, { Component, Fragment } from 'react';
import SelectorStatesCountry from './SelectorStatesCountry';
import SearchStoreLocationControls from './SearchStoreLocationControls';
import HeaderModalStores from './HeaderModalStores';
import AddZipCode from './AddZipCode';
import WithStorePreviusSelected from './WithStorePreviusSelected';
import SearchByCurrentLocation from './SearchByCurrentLocation';
import StoresRelatedSelection from './StoresRelatedSelection';

class ModalStoreLocation extends Component {
  render() {
    const {
      hideOverlay,
      showModalStatesUpdate,
      showModalDetailsUpdate,
      storeNearSelected,

      handleModalDetails,
      callForSearchStores,
      callSearchZipStateService,
      storesForZip,
      storesForState,

      stateSelected = {},
    } = this.props;

    const { storeByNear, requiredLabel } = this.props;

    return (
      <Fragment>
        {
          <section className="modalContainerStores">
            <HeaderModalStores titleHeaderMod="Selecciona tu tienda" closeModal={hideOverlay} />
            <div className="modalBodyStoreLoc">

              { !this.hasStoreSelected && storeNearSelected && (
                <WithStorePreviusSelected storeNearSelected={storeNearSelected} />
              )}

              <SearchStoreLocationControls
                storesForZip={storesForZip}
                callForSearchStores={callForSearchStores}
                storesForState={storesForState}
              />
              {
                storesForState
                  ? (
                    <SelectorStatesCountry
                      showModalStatesUpdate={showModalStatesUpdate}
                      stateSelected={stateSelected}
                    />
                  ) : (
                    <AddZipCode
                      callSearchZipStateService={callSearchZipStateService}
                      requiredLabel={requiredLabel}
                    />
                  )
              }

              { <SearchByCurrentLocation /> }

              {
                storeByNear && storeByNear.data.length ? (
                  <StoresRelatedSelection
                    hideOverlay={hideOverlay}
                    storeByNear={storeByNear}
                    handleModalDetails={handleModalDetails}
                    showModalDetailsUpdate={showModalDetailsUpdate}
                  />
                ) : ''
              }
            </div>
          </section>
        }
      </Fragment>
    );
  }
}

export default ModalStoreLocation;
